module.exports = __webpack_public_path__ + "img/persentPricing.bebc2ff7.svg";